import { Card, CardBody, Col, Row } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { InlineInputType } from "../../../../Constant";
import { INLINE_INPUT } from "../../../../Data/FormControl/CheckboxAndRadio";
import { InlineSwitche } from "./InlineSwitche";
import { InlineRadios } from "./InlineRadios";
import { InlineCheckboxs } from "./InlineCheckboxs";

const InlineInputTypes = () => {
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={InlineInputType} span={INLINE_INPUT} />
        <CardBody>
          <Row className="g-3">
            <InlineCheckboxs />
            <InlineRadios />
            <InlineSwitche />
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};

export default InlineInputTypes;
